export default class UserProducts {
  constructor($scope, $rootScope) {
    $scope.copy_from_user = this.copy_from_user.bind(this);

    this.user_id = window.user_id;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
  }

  copy_from_user() {
    var data = {
      user_id: this.user_id,
    };

    this.$rootScope.$broadcast('show_user_products_copy_from_user_dialog', data);
  }
}

UserProducts.$inject = ['$scope', '$rootScope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-products.ctrl.js